import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { Spinner } from '../Spinner'

type Props = ComponentPropsWithoutRef<'div'>

export const FullScreenSpinner: FC<Props> = ({ className, ...props }) => {
  return (
    <div
      {...props}
      className={clsx([
        // Full-screen overlay with high z-index to block interactions
        'fixed left-0 top-0 z-[1003] flex h-full w-full justify-center',
        className
      ])}
      data-testid="full-screen-spinner"
    >
      <span className={'relative top-1/2 block'}>
        <Spinner />
      </span>
    </div>
  )
}
